/**
 * WebComponents Config Service
 * ============================
 *
 * extends our baseConfig but focus only on WebComponentsConfig here
 * - typed config
 * - inject defaults for web-components
 * - inject env variables
 */

import { Inject, Injectable, Optional } from '@angular/core';

import { ENV_VARIABLES } from '../../providers/env.providers';
import { WebComponentsEnv } from '../../providers/env.type';
import { safeUri } from '../../utils/operators';
import { ConfigService } from './base-config.service';
import { defaultWebComponentsConfig } from './config.default';
import type { WebComponentsConfig } from './config.type';

@Injectable({
  providedIn: 'root',
})
export class WebComponentsConfigService extends ConfigService<WebComponentsConfig> {
  constructor(
    // eslint-disable-next-line @angular-eslint/prefer-inject
    @Optional() @Inject(ENV_VARIABLES) envVars: WebComponentsEnv,
  ) {
    super(defaultWebComponentsConfig, envVars);
  }

  openLink(uri: string, external?: boolean): void {
    if (!safeUri(uri)) {
      throw new Error(`UNEXPECTED : unsafe uri ${uri}`);
    }

    return this.config().openLink(uri, external);
  }
}
